<template>
  <div class="project-player">
    <div class = "previewing">
      <previewer id = "previewer" :project = "project" :scaled = "false" :border = "false"></previewer>
      <api-mlp-tracking-camera class = "card card-left-area"> </api-mlp-tracking-camera>
      <api-mlp-mando class = "card card-left-area" @playSketch="playSketchFromMando"> </api-mlp-mando>
    </div>

    <div id = "project-player-grid"  :class = "{ showAdmin: isAdminShown }">
      <div class = "controls card card-dark">
        <div class = "play">
          <div id = "playstopbutton">
            <button id = "play" v-if = "!isPlaying" v-on:click = "playPlaylist" class = "btn btn-bg btn-icon"><span class = "material-icons md-24">play_arrow</span></button>
            <button v-else v-on:click = "stopPlaylist" class = "btn btn-bg btn-icon"><span class = "material-icons md-24">stop</span></button>
          </div>

          <input id = "time" class = "" v-model="projectTime"/>
        </div>

        <div class = "sketch-input-selectors">
          <gallery-filter :searchParams = "searchParams" :categories = "['general', 'calls', 'tags', 'codeanalysis']" :showTitles = "true" showId = "true"></gallery-filter>
        </div>
      </div>

      <ul class = "project-list card">
        <li v-for = "(p,index) in galleryItems.results" :class = "{ 'playing': p.id === currentProject.id }" v-on:click = "openAndPlay(p,index)" :key = "p.id">
          <img class = "small-cover" :src = "p.cover" />
          <span> {{index}} {{p.name}}</span>
        </li>
      </ul>

      <editor-simple class = "editor2 card"></editor-simple>

      <div id = "project-player-admin" class = "card">
        <div class = "admin-bar">
          <button v-on:click = "toggleAdmin" class = "btn btn-bg-colored">Show/Hide admin</button>
          <button v-on:click = "toggleScreenshot" class = "btn btn-bg-colored">Show/Hide screenshot</button>
        </div>
        <div class = "admin" v-if = "project.owner">
          <div class = "admin-info">
            <p class = "admin-label">
              {{project.name}}
              <span class = "project-type" :class = "{ 'project-type-processingjs': project.config.type === 'processingjs' }">{{project.config.type}}</span>
            </p>
            <ul>
              <li>
                <a :href = "'/#/editor/' + project.id" target="_blank">Ver en Editor</a>
                <a :href = "getAdminUrl + 'project/project/' + project.id" target="_blank">Ver en Admin</a>
              </li>
              <li>
                por&nbsp;<a :href = "getAdminUrl + 'users/customuser/' + project.owner.id" target="_blank"> {{project.owner.name}} (admin)</a>
                {{project.owner.social_link}}
              </li>
              <li>{{project.description}}</li>
            </ul>

            <p class = "admin-label">Tags</p>
            <ul class = "tags">
              <button class = "btn" v-for = "t in tags" :class = "{ selected: project.tags.includes(t.id) }" v-on:click = "selectTag(t)" :key = "t.id">
                {{t.name}}
              </button>
            </ul>

            <p class = "admin-label">Educación</p>
            <ul>
              <li><a :href = "getAdminUrl + 'project/classroom/' + project.classroom" target="_blank">Ver Clase {{project.classroom}} (admin)</a></li>
            </ul>

            <p class = "admin-label">Proyectos</p>
            <ul>
              <li v-for = "u in userProjects" :key = "u.id">
                <img class = "small-cover" :src = "u.cover" />
                  <span :class = "{ 'is-not-finished': !u.is_finished }">{{u.name}}</span>
                  <a :href = "getAdminUrl + 'project/project/' + u.id" target="_blank">Admin</a>
                  <a :href = "'/#/editor/' + u.id" target="_blank">Editor</a>
              </li>
            </ul>
          </div>
          <EditorScreenshotSaver v-if = "isScreenshotShown" :showPreviewer = "true" class = "admin-edit" :project = "project" />
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import EditorSimple from '../Editor/EditorSimple'
import Previewer from '../Previewer/Previewer'
import GalleryFilter from '../Gallery/GalleryFilter'
import ApiMlpTrackingCamera from './ApiMlpTrackingCamera'
import ApiMlpMando from './ApiMlpMando'
import EditorScreenshotSaver from '../Editor/EditorScreenshotSaver'

export default {
  name: 'Player',
  components: {
    EditorSimple,
    Previewer,
    GalleryFilter,
    ApiMlpTrackingCamera,
    ApiMlpMando,
    EditorScreenshotSaver
  },
  props: {
    callid: {
      type: String,
      default: ''
    },
    tagsid: {
      type: String,
      default: ''
    },
    playlistid: {
      type: String,
      default: ''
    },
    projectid: {
      type: String,
      default: ''
    },
    classroomid: {
      type: String,
      default: ''
    },
    projecttimeinput: {
      type: String,
      default: '-1'
    },
    autoplay: {
      type: String,
      default: ''
    }
  },
  watch: {
  },
  data () {
    return {
      searchParams: {
        page: 1,
        limit: 1000,
        call: '',
        tags: [],
        is_example: false,
        is_public: true,
        is_finished: true,
        codeAnalysis: {}
      },
      projectTime: 30,
      playlistSelected: 1,
      isPlaying: false,
      playlistHead: 0,
      currentProject: { id: -1 },
      userProjects: [],
      userInfo: {},
      isAdminShown: true,
      isScreenshotShown: false
    }
  },
  computed: {
    getAdminUrl () {
      // return 'http://127.0.0.1:8000/admin/'
      return 'http://programalaplaza.medialab-prado.es/admin/'
    },
    project () {
      return this.$store.state.project
    },
    galleryItems () {
      return this.$store.state.gallery.fetched
    },
    tags: function () {
      return this.$store.state.gallery.tags
    }
  },
  methods: {
    // open a single project, no timeouts
    openAndPlay: function (p, i) {
      console.log('open and play')
      this.$store.commit('setEditorConfigProperty', { 'isSketchRunning': false })
      clearInterval(this.looper)
      clearInterval(this.aboutofinishTimeout)
      clearTimeout(this.looper)
      clearTimeout(this.aboutofinishTimeout)
      console.log('index' + i)
      this.playlistHead = i
      this.playPlaylist()

      /*
      this.isPlaying = true
      this.openProject(p)
      setTimeout(() => {
        this.$store.commit('setEditorConfigProperty', { 'isSketchRunning': true })
      }, 50)
      */
    },
    playSketchFromMando: function (id) {
      let p = {id: id}
      this.$store.commit('setEditorConfigProperty', { 'isSketchRunning': false })
      clearTimeout(this.looper)
      clearTimeout(this.aboutofinishTimeout)
      this.looper = setInterval(() => {
        this.playProject()
      }, this.projectTime * 1000)
      this.isPlaying = true
      this.$store.dispatch('fetchProject', p.id)
      setTimeout(() => {
        this.$store.commit('setEditorConfigProperty', { 'isSketchRunning': true })
      }, 50)
    },
    getUserInfo (p) {
      this.$store.dispatch('user/fetchUserIdInfo', p.owner.id).then(response => {
        console.log('cuak2', response)
        this.userInfo = response.results
      }).catch((error) => {
        console.log('fetchUserIdInfo', 'FAIL', error)
      })
    },
    openProject: function (p) {
      console.log('openProject')
      this.$store.dispatch('fetchProject', p.id)
      this.getUserInfo(p)
      this.$store.dispatch('user/fetchProjectsForUserId', p.owner.id).then(response => {
        console.log(response)
        this.userProjects = response.results
      }).catch((error) => {
        console.log('fetchProjectsForUserId', 'FAIL', error)
      })
    },
    playPlaylist: function () {
      this.playProject()
      this.looper = setInterval(() => {
        this.playProject()
      }, this.projectTime * 1000)
      this.isPlaying = true
    },
    playProject: function (p) {
      this.$store.commit('setEditorConfigProperty', { 'isSketchRunning': false })

      if (this.playlistHead >= this.galleryItems.results.length) this.playlistHead = 0
      this.currentProject = this.galleryItems.results[this.playlistHead]
      this.playlistHead++
      // console.log(this.currentProject.id)
      this.openProject(this.currentProject)

      // maximum 5s to signal on about to finish
      let timeSignalOnAboutToFinish = this.projectTime * 1000 - 5000 //* 0.8 * 1000
      // if (this.projectTimetimeSignalOnAboutToFinish > 5000) timeSignalOnAboutToFinish = 5000

      this.aboutofinishTimeout = setTimeout(() => {
        console.log('onAboutToFinish')
        this.$eventHub.$emit('rtdata', { from: 'onAboutToStop', value: 5 })
      }, timeSignalOnAboutToFinish)

      setTimeout(() => {
        this.$store.commit('setEditorConfigProperty', { 'isSketchRunning': true })
      }, 50)
    },
    stopPlaylist: function () {
      this.$store.commit('setEditorConfigProperty', { 'isSketchRunning': false })
      clearInterval(this.looper)
      this.isPlaying = false
    },
    toggleAdmin: function () {
      this.isAdminShown = !this.isAdminShown
    },
    toggleScreenshot: function () {
      this.isScreenshotShown = !this.isScreenshotShown
    },
    selectTag: function (tag) {
      if (this.project.tags.includes(tag.id)) {
        let index = this.project.tags.indexOf(tag.id)
        this.project.tags.splice(index, 1)
      } else {
        this.project.tags.push(tag.id)
      }

      // save tags
      this.$store.dispatch('handleSaveProject')
      this.openProject(this.project)
    }
  },
  mounted () {
    // console.log(parseInt(this.projecttimeinput))
    if (this.projecttimeinput !== '-1' && isNaN(parseInt(this.projecttimeinput)) === false) {
      this.projectTime = parseInt(this.projecttimeinput)
      // console.log('project time')
    }

    if (this.classroomid !== '') {
      this.searchParams.classroom = this.classroomid
    }

    if (this.callid !== '') {
      this.searchParams.call = parseInt(this.callid)
    }

    if (this.tagsid !== '') {
      this.searchParams.tags = []
      this.tagsid.split(',').forEach(t => {
        if (!isNaN(parseInt(t))) {
          this.searchParams.tags.push(parseInt(t))
        }
      })
    }
    if (this.autoplay !== '') {
      console.log(this.autoplay)
      window.setTimeout(() => this.playPlaylist(), 4000)
    }

    /*
    if (this.playlistid !== '') {
      query.params.playlist = this.playlistid
    }
    */

    let query = {
      params: this.searchParams
      /* {
        page: this.$route.params.page,
        call: this.call,
        tags: this.tags
      }
      */
    }

    this.$store.dispatch('fetchProjectList', query)
  },
  destroyed () {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.project-player {
  background: #ccc;
  display: grid;
  grid-template-columns: 250px auto;
  height: 100vh;
  overflow: hidden;
}

#project-player-grid {
  display: grid;
  grid-template: "play info info" 70px
                 "play editor editor" 200px
                 "list editor editor" auto;
  grid-template-columns: 0.75fr 1.25fr;
  grid-gap: 20px;
  padding: 20px;
  // margin: 20px;
  height: 100vh;

  &.showAdmin {
    grid-template: "play info info" 50px
                   "play info info" 200px
                   "list info info" 200px
                   "list editor editor" auto;
    grid-template-columns: 0.75fr 1.25fr;
  }
}

.previewing {
  padding: 20px 0px 20px 20px;
  margin-top: 220px;

  #previewer{
    position: absolute;
    top: 40px;
    left: 40px;
  }

}

.editor2 {
  grid-area: editor;
  border-radius: 10px;
  overflow: hidden;
  height: auto !important;
}

.controls {
  grid-area: play;
  display: flex;
  justify-content: space-between;

  select {
    flex: 2;
  }

  input {
    margin: 7px;
    padding: 10px;
    color: black;
  }

  input#time {
    max-width: 50px;
    border-radius: 100px !important;
    width: 50px;
    height: 50px;
    text-align: center;
    border: 3px solid #2fe67c !important;
    background: transparent !important;
  }

  .play {
    margin-right: 20px;

    #playstopbutton {
      padding: 0 5px;
    }
  }

  .sketch-input-selectors {
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
}

#project-player-admin {
  grid-area: info;
  padding: 10px;
  overflow: auto;
  background: @adminColor;
  color: white;

  .admin-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .admin {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    margin-top: 20px;

    a {
      color: white;
      text-decoration: underline;
    }

    .admin-info {
      .is-not-finished {
        color: red;
      }

    }

    .admin-edit {

    }

    .admin-label {
      color: white;
      margin-bottom: 5px;
      font-weight: 800;
    }

    ul {
      margin-bottom: 20px;
    }

    .project-type {
      background: #fff5;
      border-radius: 2px;
      padding: 5px 8px;

      &.project-type-processingjs {
        background: red;
      }
    }
  }

  .tags {
    button {
      color: #000a;
      background: #0003;
      padding: 5px 8px;
      border-radius: 2px;
      // box-shadow: 1px 1px 1px 0px #0002;
      display: inline-block;
      margin: 5px 5px 5px 0px;

      &.selected {
        color: white;
        background: #222;
      }
    }
  }
}

.small-cover {
  border: 1px solid black;
  width: 30px;
  height: 30px;
  object-fit: cover;
}

li {
  display: flex;
  display: flex;
  align-items: center;

  * {
    margin-right: 5px;
  }
}

.project-list {
  grid-area: list;
  overflow:auto;

  li {
    padding: 5px;
    cursor: pointer;
  }

  li:hover {
    background: lighten(@accentColor, 20%);
  }
  .playing {
    background: @accentColor;
  }
}

.debug2 {
  position: absolute;
  z-index: 12;

  p {
    background: white;
    padding: 12px;
    margin: 12px;
  }
}
.abs {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 500px;
  height: 500px !important;
}

.card {
  background: white;
  border-radius: 2px;
  box-shadow: 0 0 3px 0 #0005;

  &.card-dark {
    background: @backgroundColor;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ProjectPlayer/ProjectPlayer.vue